import { render, staticRenderFns } from "./Rack.vue?vue&type=template&id=531c8a54&scoped=true&"
import script from "./Rack.vue?vue&type=script&lang=js&"
export * from "./Rack.vue?vue&type=script&lang=js&"
import style0 from "./Rack.vue?vue&type=style&index=0&id=531c8a54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531c8a54",
  null
  
)

export default component.exports